package tools

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import common.frontend.api.Io
import org.ssoft.common.server.icons.IconIO
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.navTo_IconsListingUI
import tk.mallumo.compose.navigation.navTo_ResourceListingUI
import ui.resource.ResourceListingArgs

object GlobalObjectShare {

    abstract class Task<T>(val key: String) {

        abstract fun consume()

        abstract fun set(data: T)

        class PickImage(
            key: String,
            val onSelected: (Set<Io.ListingResource.Item>) -> Unit,
        ) : Task<Set<Io.ListingResource.Item>>(key) {

            private var data: Set<Io.ListingResource.Item> = setOf()

            override fun consume() {
                onSelected(data)
            }

            override fun set(data: Set<Io.ListingResource.Item>) {
                this.data = data
            }

        }

        class PickIcon(
            key: String,
            val onSelected: (IconIO.Result.Item) -> Unit,
        ) : Task<IconIO.Result.Item>(key) {

            private var data: IconIO.Result.Item? = null

            override fun consume() {
                data?.also(onSelected)
            }

            override fun set(data: IconIO.Result.Item) {
                this.data = data
            }

        }
    }

    private val tasks = mutableListOf<Task<*>>()

    fun register(task: Task<*>) {
        tasks += task
    }

    fun consume(key: String) {
        val jobs = tasks
            .filter { it.key == key }
            .toSet()
            .onEach {
                it.consume()
            }
        tasks -= jobs
    }

    @Composable
    fun Consumer(vararg key: String) {
        LaunchedEffect(Unit) {
            key.forEach {
                consume(it)
            }
        }
    }

    @Composable
    fun Consumer(keys: List<String>) {
        LaunchedEffect(Unit) {
            keys.forEach {
                consume(it)
            }
        }
    }

    fun launchImagePicker(
        key: String,
        nav: Navigation,
        args: ResourceListingArgs,
        onSelected: (Set<Io.ListingResource.Item>) -> Unit
    ) {
        register(
            Task.PickImage(
                key = key,
                onSelected = onSelected
            )
        )
        nav.navTo_ResourceListingUI(args.copy(pickerMode = true))
    }

    fun launchIconPicker(key: String, nav: Navigation, onSelected: (IconIO.Result.Item) -> Unit) {
        register(
            Task.PickIcon(
                key = key,
                onSelected = onSelected
            )
        )
        nav.navTo_IconsListingUI()
    }


    fun onImagePick(data: Set<Io.ListingResource.Item>) {
        tasks.filterIsInstance<Task.PickImage>()
            .forEach {
                it.set(data)
            }
    }

    fun onIconPick(data: IconIO.Result.Item) {
        tasks.filterIsInstance<Task.PickIcon>()
            .forEach {
                it.set(data)
            }
    }
}
